import { render, staticRenderFns } from "./driver_info.vue?vue&type=template&id=684022f0&scoped=true&"
import script from "./driver_info.vue?vue&type=script&lang=js&"
export * from "./driver_info.vue?vue&type=script&lang=js&"
import style0 from "./driver_info.vue?vue&type=style&index=0&id=684022f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684022f0",
  null
  
)

export default component.exports